'use strict';

/*global app*/
/*global services*/
/*global nl2br*/
/*global normalizeInput*/
/*global invokeCallback*/
/*global resClose*/
/*global resSuccess*/

function SelectService() {
  this.modal = null;
  this.data = null;

  this.init();
}

SelectService.prototype = $.extend({}, {
  constructor: 'SelectService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    this.modal.contentDOM().on('click', '.select-service__item', function () {
      _this.chooseValue($(this).data('id'));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  chooseValue: function chooseValue(id) {
    var _this = this;

    _this.modal.close(function () {
      invokeCallback(_this.data.callback, resSuccess, id);
    });

    return _this;
  },

  createHtmlList: function createHtmlList(list, value) {
    var html = '';

    html += '<div>';

    $.each(list, function (key, item) {
      html += '<button data-id="' + item.id + '" class="btn btn-' + (value && value === item.id ? 'success' : 'primary') + ' btn-lg full-width offset-bottom-5 select-service__item">' + item.abbr + '</button>';
    });

    html += '</div>';

    return html;
  },

  selectValueWithRes: function selectValueWithRes(data, callback) {
    var _this = this;

    _this.value = null;

    _this.data = normalizeInput(data);
    _this.data.callback = callback;

    var content = data.content || '';

    if (data.asHtml && content) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    content += _this.createHtmlList(_this.data.list, _this.data.value);

    _this.modal.empty().open({
      title: data.title,
      saveBtnTitle: app.t('form.insert'),
      height: 'auto',
      width: 'md',
      keyboardClose: false,
      content: content,
      closeCallBack: function () {
        invokeCallback(_this.data.callback, resClose);
      }
    });

    return _this;
  },

  selectValue: function selectValue(data, callback) {
    var _this = this;

    return _this.selectValueWithRes(data, function (res, resData) {
      if (res === resSuccess) {
        invokeCallback(callback, resData);
      }
    });
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-select');

    _this.registerCallbacks();

    return _this;
  }
});
